import React from 'react'
import { DownIcon, SendBtn } from '../utils/icons'

function Feedback() {
    return (
        <div className='space-y-7'>
            <div className='flex justify-between items-center'>
                <h1 className='font-semibold text-lg'>Feedback</h1>
                <button className='flex items-center gap-2 text-xs'>Most relevant <DownIcon /></button>
            </div>
            <h1 className='font-semibold'>Share your feedback with M3</h1>
            <div className='shadow-[0px_4px_18px_0px_#4B465C1A] p-3 rounded-2xl'>
                <select className='w-full  outline-none'>
                    <option value='0'>My feedback is related to</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                </select>
            </div>
            <div className="flex items-center p-3 rounded-3xl">
                <input
                    placeholder="Start sharing your thoughts ..."
                    className="w-full bg-transparent border-none outline-none"
                />
                <button>
                    <SendBtn />
                </button>
            </div>
        </div>
    )
}

export default Feedback